export default __webpack_public_path__ + "static/media/logo.390b2008.jpg";